import { Component, Input } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DropdownFilter, TableActionButton, TableColumn } from '../table';

@Component({
  selector: 'app-table-modal',
  templateUrl: './table-modal.component.html',
  styleUrl: './table-modal.component.scss'
})
export class TableModalComponent {
  @Input()
  cols: Array<TableColumn>;

  @Input()
  elements: Array<any>;

  @Input()
  modelName = 'registros';

  @Input()
  dropdownFilters: { [field: string]: Array<DropdownFilter> };

  @Input()
  showHeader = false;

  @Input()
  showTitle = true;

  @Input()
  exportPdf = true;

  @Input()
  exportExcel = true;

  @Input()
  addButton = true;

  @Input()
  actionButtons: Array<TableActionButton> | undefined;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.cols = this.config.data.cols;
    this.elements = this.config.data.elements;
    this.modelName = this.config.data.modelName;
    this.dropdownFilters = this.config.data.dropdownFilters;
    this.showHeader = this.config.data.showHeader ?? false;
    this.showTitle = this.config.data.showTitle ?? true;
    this.exportPdf = this.config.data.exportPdf ?? true;
    this.exportExcel = this.config.data.exportExcel ?? true;
    this.addButton = this.config.data.addButton ?? true;
    this.actionButtons = this.config.data.actionButtons;
    if (!this.cols || !this.elements) {
      throw 'TableModalComponent: please provide the array of columns and the array of elements to show';
    }
  }
}
